import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "@core/shared/services/user.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormService} from "@core/shared/services/form.service";
import {mustMatchValidator} from "@core/shared/validators/must-match.validator";
import {Observable, of} from "rxjs";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {map} from "rxjs/operators";
import {HttpResponse} from "@angular/common/http";

@Component({
    selector: 'app-core-page-user-reset-password',
    templateUrl: './page-user-reset-password.component.html',
    styleUrls: ['./page-user-reset-password.component.scss'],
    providers: [
        FormService
    ],
    standalone: false
})
export class PageUserResetPasswordComponent implements OnInit {

    public loginLogoUrl$: Observable<SafeUrl>;

    public poweredByTywin: boolean = false;

    public minLengthPassword: number = 8;

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _sanitizer: DomSanitizer,
        private _activatedRoute: ActivatedRoute,
        private _formBuilder: UntypedFormBuilder,
        private _translateService: TranslateService,
        private _userService: UserService,
        private _snackBar: MatSnackBar,
        public formService: FormService
    ) {
    }

    ngOnInit(): void {

        this._initLoginLogo();

        this._initForm();
    }

    private _initLoginLogo(): void {

        const params: string[] = [];

        if('choicePreference' in this._activatedRoute.snapshot.queryParams){

            params.push(`choicePreference=${ this._activatedRoute.snapshot.queryParams['choicePreference'] as string }`);
        }

        if('registrationAffiliation' in this._activatedRoute.snapshot.queryParams){

            params.push(`registrationAffiliation=${ this._activatedRoute.snapshot.queryParams['registrationAffiliation'] as string }`);
        }

        this.loginLogoUrl$ = Boolean(params.length) ? this._userService.getLoginLogoAPI(params).pipe(
            map((response: HttpResponse<Blob>): SafeUrl => {

                this.poweredByTywin = Boolean(parseInt(response.headers.get('Powered-By-Ty-Win')));

                const imageUrl: string = URL.createObjectURL(response.body);

                return this._sanitizer.bypassSecurityTrustUrl(imageUrl);
            })
        ) : of('assets/images/logo_tywin.png');
    }

    private _initForm(): void {

        this.formService.form = this._formBuilder.group({
            password: ['', [Validators.required, Validators.minLength(this.minLengthPassword)]],
            confirmPassword: ['', Validators.required],
        }, {
            validators: [
                mustMatchValidator('password', 'confirmPassword')
            ]
        });

        this.formService.submitCallback = (): void => {

            const data: object = {
                password: this.form.get('password').value
            };

            this._userService.resetAccountPasswordAPI(this._route.snapshot.params['token'], data).subscribe((): void => {

                this._snackBar.open(this._translateService.instant('user.password.reset.success.self.value'), this._translateService.instant('notification.close.action.value'), {
                    duration: 8000
                });

                this._router.navigate(['signin']);
            });
        };
    }

    get form(): UntypedFormGroup {

        return this.formService.form;
    }
}

